import React from 'react';
import { trackClick } from 'utility/analytics';
import { Button } from 'theme/Button';
import history from 'historyContainer';
import { LG, XL, XXXL } from '@zendeskgarden/react-typography';
import { variables } from 'theme/variables';
import Flex, { FlexItem } from 'styled-flex-component';
import { Page } from 'theme/Page';
import PageViewWrapper from 'higherOrder/PageViewWrapper';
import { ErrorWrapper } from './error.styles.js';

const { spacing } = variables;

const ErrorPage = (props) => {
  return (
    <Page>
      <ErrorWrapper>
        <Flex style={{ height: '90%' }} alignCenter justifyCenter>
          <FlexItem>
            <LG grey center style={{ padding: `0 0 ${spacing} 0` }} tag="h1">
              404, Not Found.
            </LG>
            <XXXL bold center style={{ padding: `0 0 ${spacing} 0` }} tag="h1">
              Sorry, something went wrong.
            </XXXL>
            <LG paddingBottomLg center tag="h3">
              We could not find the page you were looking for. Please try again.
            </LG>
            <Button
              center
              large
              onClick={() => {
                trackClick('goToRoot', 'Go Back Home', 'Error');
                history.push('/');
              }}
              primary
            >
              Go Back Home
            </Button>
          </FlexItem>
        </Flex>
      </ErrorWrapper>
    </Page>
  );
};

export default PageViewWrapper(ErrorPage, { pageName: 'ErrorPage' });
